import { FormattedMessage } from "react-intl";
import { FiAlertCircle, FiTrash2 } from "react-icons/fi";

import {
  StyledModal,
  ModalTitle,
  IconCircle,
  Question,
  OrderNumber,
  Subtitle,
  FooterContainer,
  NoButton,
  YesButton,
} from "./styles";

export default function CancelOrderModal({
  open,
  orderNumber,
  onConfirm,
  onClose,
  loading,
}) {
  return (
    <StyledModal
      open={open}
      onCancel={loading ? undefined : onClose}
      footer={null}
      width={480}
      centered
      maskClosable={!loading}
      title={
        <ModalTitle>
          <FiAlertCircle />
          <FormattedMessage id="cancel_order" />
        </ModalTitle>
      }
    >
      <IconCircle>
        <FiTrash2 />
      </IconCircle>

      <Question>
        <FormattedMessage
          id="cancel_order_confirmation"
          values={{ number: <OrderNumber>{orderNumber}</OrderNumber> }}
        />
      </Question>

      <Subtitle>
        <FormattedMessage id="cancel_order_irreversible" />
      </Subtitle>

      <FooterContainer>
        <NoButton onClick={onClose} disabled={loading}>
          <FormattedMessage id="no" />
        </NoButton>
        <YesButton onClick={onConfirm} loading={loading}>
          <FormattedMessage id="yes_cancel_order" />
        </YesButton>
      </FooterContainer>
    </StyledModal>
  );
}
